


































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import FileUpload from "vue-upload-component";

@Component ({
  components: {
    FileUpload
  }
})
export default class ImageUpload extends Vue {
  files = [];
  uploadErrors = [];
  accept = ".png,.gif,.bmp,.jpeg,.jpg";
  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (!/\.(jpeg|jpg|gif|png|bmp)$/i.test(newFile.name)) {
        this.uploadErrors.push("File type not allowed");
        return prevent();
      }
      const oneMB = 1024 * 1024 * 1;
      if (newFile.size > oneMB) {
         this.uploadErrors.push("File must be smaller than 1 MB");
        return prevent();
      }
    }
  }

  updateFiles (files) {
    const mappedFiles = files.map(f => f.file);
    this.$emit("onFiles", mappedFiles);
  }

  deleteFile (file) {
    const uploadComponent: any = this.$refs.upload;
    uploadComponent.remove(file);
  }

  clearErrors () {
    this.uploadErrors = [];
  }

  mounted () {
    // Reason:BEND-6906 WAVE tool returns an error on vue-upload-component
    // because it adds an empty label element while generating the template.
    document.querySelector("div.drag-container > div > div > span > label").innerHTML = "upload";
  }
}
